import "./Privacy.module.css";
import Header from "@/reusable_sections/Header";
import Hero from "./sections/Hero";
import HostingInformationen from "./sections/HostingInformationen";
import Footer from "@/reusable_sections/Footer";
export default function PrivacyPage() {
  return <div>
      <Header />
      <Hero />
      <HostingInformationen />
      {/* Die Sektionen DataTransfer und RechtlicheHinweise wurden entfernt, 
          da deren Inhalte nun vollständig in HostingInformationen integriert sind. */}
      <Footer />
    </div>;
}